//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  
  import { LookupModel } from './LookupModel';
  
  export class PhysicalAddressModel {
      static readonly $typeName = 'PhysicalAddressModel';
      public key: string;
      public cityName: string;
      public country: LookupModel;
      public countyArea: LookupModel;
      public firstStreetAddress: string;
      public postalCode: string;
      public secondStreetAddress: string;
      public stateProvince: LookupModel;
      public type: LookupModel;
      
  }



// WEBPACK FOOTER //
// ./src/app/common/models/PhysicalAddressModel.ts